import { render, staticRenderFns } from "./imgE.vue?vue&type=template&id=367fcb8c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367fcb8c')) {
      api.createRecord('367fcb8c', component.options)
    } else {
      api.reload('367fcb8c', component.options)
    }
    module.hot.accept("./imgE.vue?vue&type=template&id=367fcb8c", function () {
      api.rerender('367fcb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgE.vue"
export default component.exports